import { Route } from 'vue-router';

export const isCashbackRoute = (route: Route): boolean => {
  return isCashbackCreateRoute(route) || isCashbackUpdateRoute(route);
};

export const isCashbackCreateRoute = (route: Route): boolean => {
  return route.name === 'CashbackCreate';
};

export const isCashbackUpdateRoute = (route: Route): boolean => {
  return route.name === 'CashbackUpdate';
};
